import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RequestFormHeader } from '@Types/index';
import { getDefaultRequestState } from '@Features/utils/getDefaultRequestState';

interface ResignationRequestState {
  resignationRequest: RequestFormHeader;
}

const initialState: ResignationRequestState = {
  resignationRequest: getDefaultRequestState(),
};

const resignationRequestSlice = createSlice({
  name: 'resignationRequest',
  initialState,
  reducers: {
    setResignationRequest: (
      state: ResignationRequestState,
      action: PayloadAction<RequestFormHeader | null>
    ) => {
      const { payload } = action;

      if (payload === null) {
        state.resignationRequest = getDefaultRequestState();
      } else {
        state.resignationRequest = payload;
      }
    },
  },
});

const { actions } = resignationRequestSlice;

export const resignationRequestActions = {
  ...actions,
};

export default resignationRequestSlice;
